import { PlaybackPerformanceMonitor } from './PlaybackPerformanceMonitor';
import { PlayerAdapter } from './PlayerAdapter';
import { PerformanceStatistics, PlaybackStatistics, StreamTimelineEvent } from '@quickplay/player-interface';

export function createPlaybackPerformanceMonitor(
  playerAdapterProvider: () => PlayerAdapter | null,
): PlaybackPerformanceMonitor {
  let totalWatchedDurationWhenProgramSwitched = 0;

  function resetProgramDuration(): void {
    const adapter = playerAdapterProvider();
    const snapshot = adapter?.playbackStatistics;
    if (snapshot) {
      totalWatchedDurationWhenProgramSwitched = snapshot.playTime;
    }
  }

  function statisticsFor(snapshot: PlaybackStatistics | undefined): PerformanceStatistics {
    return {
      programWatchedDuration: snapshot ? snapshot.playTime - totalWatchedDurationWhenProgramSwitched : 0,
    };
  }

  return {
    get performanceStatistics(): PerformanceStatistics {
      return statisticsFor(playerAdapterProvider()?.playbackStatistics);
    },

    statisticsFor,

    onStreamTimelineEvent(eventName: StreamTimelineEvent): void {
      if (eventName !== StreamTimelineEvent.LIVE_PROGRAM_START) {
        return;
      }

      resetProgramDuration();
    },
  };
}
